import { APIStatus, CheckStatus, SavedStatus } from '../config/CustomEnums';
import {
  getAfcCronjobRecords,
  getOneAfcCronjobRecord,
  createAfcCronjobRecord,
  updateAfcCronjobRecord,
  deleteAfcCronjobRecord
} from '../services/AfcCronjobRecordAPIHelper';
import {
  convertCursorToNumber,
  convertNumberToCursor,
  convertPKToId,
  delay,
  getObjectFromSessionStorage,
  removeFromSessionStorage,
  saveToSessionStorage,
} from '../utils';

import { getCampignPeriodDateTime } from '../utils/TimeFormatUtil';
import { apiWithResponseHandle, loading } from './LoadingUtil';

const getInitialState = () => ({
  oneAdminGroup: {},
  listDisplayFields: [
    { displayName: 'ID', fieldName: 'pk', linked: true },
    { displayName: 'Source', fieldName: 'source' },
    { displayName: 'Start Datetime', fieldName: 'startDatetime' },
    { displayName: 'End Datetime', fieldName: 'endDatetime' },
    { displayName: 'Status', fieldName: 'status' },
  ],
  afcCronjobRecords: [],
  totalCount: 0,
  pageInfo: {
    startCursor: '',
    endCursor: '',
    hasNextPage: false,
    hasPreviousPage: false,
  },
  currentPage: 0,
  totalPage: 0,
  checkedList: [],
  checked: CheckStatus.initOrNotChecked,
  errorFields: {},
  saved: SavedStatus.init,
  formChanged: false,
  apiStatus: APIStatus.none,
  afcCronjobRecord: {}
});


const parseAfcCronjobRecord = (item) => {
  return {
    ...item,
    creationDate: getCampignPeriodDateTime(item.creationDate),
    startDatetime: getCampignPeriodDateTime(item.startDatetime),
    endDatetime: getCampignPeriodDateTime(item.endDatetime)
  };
};


const parseAfcCronjobRecords = (data) => {
  return data.map((item) => parseAfcCronjobRecord(item.node));
};

export default {
  namespace: 'afcCronjobRecords',
  state: getInitialState(),

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clearData(state, { payload }) {
      return { ...state, ...getInitialState() };
    },
  },

  effects: {
    getAfcCronjobRecords: [
      function* ({ payload }, { call, put }) {
        const page = payload.page;
        const pageCursor = payload.page
          ? convertNumberToCursor((page - 1) * 20 - 1)
          : '';
        const serviceArgs = [
          getAfcCronjobRecords,
          pageCursor,
          payload.reverse,
          payload.search,
          payload.moreSearch,
        ];
        function* onSuccess(data) {
          const pageInfo = data?.afcCronjobRecords?.pageInfo;
          const currentLastCursor = pageInfo?.endCursor1;
          const totalCount = data?.afcCronjobRecords?.totalCount;
          yield put({
            type: 'updateState',
            payload: {
              afcCronjobRecords: parseAfcCronjobRecords(data?.afcCronjobRecords?.edges),
              pageInfo: {
                startCursor: convertCursorToNumber(pageInfo?.startCursor) + 1,
                endCursor: convertCursorToNumber(pageInfo?.endCursor) + 1,
              },
              currentLastCursor,
              totalCount,
              totalPage: Math.ceil(totalCount / 20),
            },
          });
        }

        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
    getOneAfcCronjobRecord: [
      function* ({ payload }, { call, select, put, all }) {
        yield put({
          type: 'updateState',
          payload: { apiStatus: APIStatus.calling },
        });
        const id = convertPKToId('AfcCronjobRecordNode', payload.id);
        const serviceArgs = [getOneAfcCronjobRecord, id];
        console.log('@119', payload, id)
        function* onSuccess(data) {
          console.log('getOneAfcCronjobRecord onSuccess :', data);
          yield all([
            put({
              type: 'updateState',
              payload: { apiStatus: APIStatus.none, afcCronjobRecord: data.afcCronjobRecord },
            }),
          ]);
        }
        function* onError(err) {
          console.log('getOneAfcCronjobRecord onError :', err);
          yield put({
            type: 'updateState',
            payload: { apiStatus: APIStatus.failed },
          });
        }
        function* onArgumentsError(err) {
          console.log('getOneAfcCronjobRecord arguments error :', err);
          yield put({
            type: 'updateState',
            payload: { apiStatus: APIStatus.failed },
          });
        }
        yield apiWithResponseHandle(
          serviceArgs,
          onSuccess,
          onError,
          onArgumentsError,
        );
      },
      { type: 'takeLatest' },
    ],

  },
};
